import React, { useState, useEffect } from 'react';
import { useDispatch , useSelector } from 'react-redux';
import toast from 'react-hot-toast'

import Modal from './Modal';
import classes from './ApplyLeave.module.scss';
import BreadCrumb from '../../utilities/BreadCrumb/BreadCrumb';
import { openCloseApplyLeave } from '../../Redux/action/interactions';
import { leaveBalance, pendingLeaves, restrictedHoliday, sanctionOfficer } from '../../API/API';

const ApplyLeave = () => {
  const [balance, setBalance] = useState({CL:"0",LHAP:"0",LAP:"0",RH:"0"});
  const [pending, setPending] = useState([]);

  const dispatch = useDispatch();
  const state = useSelector(state=>state.interactions.openLeaveForm)


  const userID = localStorage.getItem('userID');
  const data = JSON.parse(localStorage.getItem('data'));

  useEffect(() => {
    if(data !==null){
      if(data.usr_boss === null){
        toast.error("You've No Reporting Officer Assigned",{
          duration:4500
        })
        return;
      }
    }
    if (userID !== null && data !== null) {

      leaveBalance(userID, data.empid, data.token)
        .then(response => {
          setBalance({
            CL:response.data.CL?response.data.CL:0,
            RH:response.data.RH?response.data.RH:0,
            LHAP:response.data.LHAP?response.data.LHAP:0,
            LAP:response.data.LHAP?response.data.LHAP:0          
          })
          
        })
        .catch()

      pendingLeaves(userID, data.empid, data.token)
        .then(response => {
          setPending(response.data)
        })
        .catch()
    }
  }, [state])


  return (
    <>
      <BreadCrumb name="Apply Leave" />
      <div className={classes.Container}>
        {state && <Modal lvBalance={balance}/>}
        <div className={classes.LeaveBalanceDiv}>
          {/* <h2>Remaining Leaves</h2>
          <div className={classes.BalanceDiv}>
            <div>
              <h1>CL</h1>
              <p>{balance.CL!==null?balance.CL:0}</p>
            </div>
            <div>
              <h1>RH</h1>
              <p>{balance.RH!==null?balance.RH:0}</p>
            </div>
            <div>
              <h1>LHAP</h1>
              <p>{balance.LHAP!==null?balance.LHAP:'0'}</p>
            </div>
            <div>
              <h1>LAP</h1>
              <p>{balance.LAP!==null?balance.LAP:0}</p>
            </div> 
          </div> */}
          <button onClick={() => {dispatch(openCloseApplyLeave(true))}}>Apply Leave</button>
        </div>

        <div className={classes.PendingLeavesDiv}>
          <h2 style={{ textAlign: "center" }}>Applied Leaves Status</h2>
          {pending !== null ? (pending.map((item, index) => {
            return (
              <div key={index} className={classes.PendingDivs}>
                <div style={{ display: "flex", justifyContent: "space-around" }}>
                  <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    <div>
                      <b>Leave From:</b> <br /> {item.leaveFrom}
                      
                    </div>
                    <div>
                      <b>Status:</b><br /> {item.status === "Approved" ? <div style={{ color: "#47D316", fontWeight: "bold" }}>{item.status}</div> : <div style={{ color: "#EA6A47", fontWeight: "bold" }}>{item.status}</div>}
                    </div>
                    <div>
                      <b>Days:</b> {item.numberOfDaysForLeave}
                    </div>
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    <div>
                      <b>Leave Till:</b> <br />{item.leave_to}
                    </div>
                    <div>
                      <b>Applied Date:</b> <br />{item.leaveAppliedDate}
                    </div>
                    <div>
                      <b>Leave Type:</b> {item.leaveType}
                    </div>
                  </div>
                </div>
                <div style={{ textAlign: "center" }}>
                  <b>Sanctioning Authority:</b> <br />{item.sanctionedBy}
                </div>
              </div>
            )
          })) : "No Leaves To Show"}

        </div>
      </div>
    </>
  )
}

export default ApplyLeave
